export default {
  iface: {},

  listRows: [],
  listStat: null,
  listFilters: {
    users: [],
    teamIds: [],
    teamGroupIds: [],
    goalTypeCodes: [],
    reasonCodes: [],
    sourceCodes: [],
    specCodes: [],
    skillType: null,
    statuses: [],
    period: null,
    mentors: [],
    hasOverdue: null,
  },

  supervisedBadge: null,
  supervisedRows: [],
  supervisedFilters: {
    users: [],
    statuses: [],
    roles: [],
    employeeName: '',
    period: null,
    waitingDecision: null,
  },

  tasksStat: null,
  proposeAvailability: {},
  directSupervisors: [],
  header: null,
  decisions: [],
  commonMaterials: [],
  blockMaterials: [],
  skills: [],
  materialComments: [],

  isLoading: false,
  isLoadingIface: false,
  isLoadingDirectSupervisors: false,
  isSubmitting: false,

  errors: null,
  validationErrors: null,
};
